import { Grid } from 'antd';
import { resolveWorkbenchMobileLayout } from '../utils/workbenchLayout';

const { useBreakpoint } = Grid;

export function useWorkbenchMobileLayout(forceMobileLayout = false): boolean {
  const screens = useBreakpoint();
  return resolveWorkbenchMobileLayout(screens, forceMobileLayout);
}
